module.exports = __webpack_public_path__ + "img/gelbetonne.5b6b95a3.svg";